import _defineProperty from "@babel/runtime/helpers/defineProperty";
import COLORS from 'tstyles/variables.scss';
import { VIEW_TYPE } from '../constants/note.general';
export var TIME_STAMP_SEPARATOR = '|';
export var VIEW_TYPE_TO_TIME_STAMP_COLOR = _defineProperty({}, VIEW_TYPE.COMPACT, COLORS.atomic);